export async function getCommentsAction(documentId) {
    return await buildComentAction('GET', `comments/get/${documentId}`);
}
export async function addCommentAction(comment, documentId) {
    return await buildComentAction('POST', 'comments/add', {
        content: comment.content,
        documentNodeRef: documentId,
        files: comment.files
    });
}
export async function removeCommentAction(comment, documentId, parentCommentId) {
    return await buildComentAction('DELETE', 'comments/remove', {
        parentCommentPath: `${(parentCommentId ? `${parentCommentId}|` : "")}${comment?.id}`,
        documentNodeRef: documentId,
        userName: comment?.userName
    });
}
async function buildComentAction(method, url, body) {
    const requestOptions = {
        method: method,
        headers: { 'Content-Type': 'application/json' }
    };
    if (body) requestOptions.body = JSON.stringify(body);
    const response = await fetch(url, requestOptions);
    if (!response.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
    else {
        const result = await response.json();
        return Array.isArray(result) ? result : undefined;
    }
}